import ModalInformationExtranetPreview from './pages/preview';
customElements.define('modal-information-preview', ModalInformationExtranetPreview,{extends: 'div'});

require('./../common/components/container');